<script setup lang="ts">
import { BlockCard } from '~/lib/services/content/content.blocks.dtos'

defineProps<{ block: BlockCard }>()
</script>

<template>
  <figure class="mt-20 h-full w-full">
    <img
      class="h-full w-full"
      :src="block.image?.url"
      :alt="block.image?.alternativeText || undefined"
    />
  </figure>
</template>
